import { monteurApi } from '../common/monteur-api';
export var rolesApi = monteurApi
    .enhanceEndpoints({
    addTagTypes: ['Role']
})
    .injectEndpoints({
    endpoints: function (builder) { return ({
        getRoles: builder.query({
            query: function (hasUserCount) { return "Role/get-all?hasUserCount=".concat(hasUserCount); },
            providesTags: ['Roles']
        }),
        getRolesByName: builder.query({
            query: function (query) {
                return "Role/get-roles-by-name?hasUserCount=".concat(query.hasUserCount, "&roleName=").concat(query.roleName);
            },
            providesTags: ['Roles']
        }),
        getRolesByCompany: builder.query({
            query: function (query) { return ({
                url: "Role/get-by-company",
                method: 'POST',
                body: query
            }); },
            providesTags: ['Roles']
        }),
        getRole: builder.query({
            query: function (roleId) { return ({
                url: "Role/get-by-id?id=".concat(roleId),
                method: 'GET'
            }); }
        }),
        createRole: builder.mutation({
            query: function (role) { return ({
                url: 'Role/create',
                method: 'POST',
                body: role
            }); },
            invalidatesTags: ['Roles', 'Role']
        }),
        updateRole: builder.mutation({
            query: function (role) { return ({
                url: 'Role/update',
                method: 'POST',
                body: role
            }); },
            invalidatesTags: ['Roles', 'Role', 'Users']
        }),
        updateRoleStatus: builder.mutation({
            query: function (role) { return ({
                url: 'Role/update-status',
                method: 'POST',
                body: role
            }); },
            invalidatesTags: ['Roles', 'Role', 'Users']
        }),
        getRolePermissions: builder.query({
            query: function (roleId) { return ({
                url: "Role/get-permissions?id=".concat(roleId),
                method: 'GET'
            }); },
            keepUnusedDataFor: 0
        }),
        updateRolePermissions: builder.mutation({
            query: function (rolePermissions) { return ({
                url: 'Role/update-permissions',
                method: 'POST',
                body: rolePermissions
            }); },
            invalidatesTags: ['Roles', 'Role', 'Users']
        }),
        getPaginatedRoles: builder.query({
            query: function (query) { return ({
                url: "Role/get-paginated",
                method: 'POST',
                body: query
            }); },
            providesTags: ['Roles']
        })
    }); }
});
export var useGetRolesQuery = rolesApi.useGetRolesQuery, useGetRolesByNameQuery = rolesApi.useGetRolesByNameQuery, useLazyGetRolesByCompanyQuery = rolesApi.useLazyGetRolesByCompanyQuery, useCreateRoleMutation = rolesApi.useCreateRoleMutation, useUpdateRoleMutation = rolesApi.useUpdateRoleMutation, useLazyGetRoleQuery = rolesApi.useLazyGetRoleQuery, useUpdateRoleStatusMutation = rolesApi.useUpdateRoleStatusMutation, useLazyGetRolePermissionsQuery = rolesApi.useLazyGetRolePermissionsQuery, useUpdateRolePermissionsMutation = rolesApi.useUpdateRolePermissionsMutation, useGetPaginatedRolesQuery = rolesApi.useGetPaginatedRolesQuery;
